var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-bread-crumb"},[_c('el-breadcrumb',{attrs:{"separator":" "}},[_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.tag1))]),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.tag2))]),(_vm.tag3)?_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.tag3))]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }